import React, {FC, useContext} from 'react';
import {Redirect} from 'react-router-dom';
import {firstPageComponent} from '../../utils/FirsPageComponent';

const Root: FC = () => {
  const userRole = localStorage.getItem('role')!;
  const isAuth = localStorage.getItem('token');
  if (isAuth) {
    return <Redirect to={firstPageComponent(userRole)} />;
  } else {
    return <Redirect to="/login" />;
  }
};

export default Root;
